// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-layout-dialog {
  background: #fff;
  border-radius: 4px;
  width: 360px;
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  box-shadow: 0 0 20px #0003;
}

.graph-layout-dialog__item:nth-child(odd) {
  background: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphLayout/GraphLayoutDialog.css","webpack://./services/frontend/app/components/Graph/GraphLayout/GraphLayoutDialog.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".graph-layout-dialog {\n  background: #ffffff;\n  border-radius: 4px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  position: absolute;\n  top: 50%;\n  right: 50%;\n  transform: translate(50%, -50%);\n  width: 360px;\n}\n\n.graph-layout-dialog__item:nth-child(odd) {\n  background: #f5f5f5;\n}\n",".graph-layout-dialog {\n  background: #fff;\n  border-radius: 4px;\n  width: 360px;\n  position: absolute;\n  top: 50%;\n  right: 50%;\n  transform: translate(50%, -50%);\n  box-shadow: 0 0 20px #0003;\n}\n\n.graph-layout-dialog__item:nth-child(odd) {\n  background: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
